<template>
    <div class="summary-statistics-employer-block-main">
        <div class="main-block" v-loading="loading">
            <template>
                <div class="title">
                    {{ title }}
                </div>
                <div v-for="(value, name) in summaryStat" :key="name" class="summary-stat">
                    <div class="row">
                        <div>{{ getName(statColumns, name) }}</div>
                        <div>{{ value }}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import '@/assets/styles/summary-statistics-employer.scss';
import { formatFinance } from '@/common/utilities';
import employerInfoMixin from '@/mixins/employerInfo';
import dateHelper from '@/helpers/dateHelper';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'SummaryStatisticsEmployer',
    props: {
        employerId: {
            type: [Number, String],
            default: 0
        },
        reportDate: {
            type: String,
            default: ''
        }
    },
    mixins: [
        employerInfoMixin
    ],
    data() {
        return {
            amount: [],
            loading: false,
            employerPositionId: 0,
            summaryStat: {},
            statColumnsMeasurer: [
                { name: 'Кол-во рабочих дней', id: 'workingDaysCount', fieldClass: 'grid-cell' },
                { name: 'Кол-во замеров', id: 'measurementsCount', fieldClass: 'grid-cell' },
                { name: 'Кол-во ОДЗ', id: 'refusesBeforeMeteringCount', fieldClass: 'grid-cell' },
                { name: 'Кол-во техотказов', id: 'techRefusesCount', fieldClass: 'grid-cell' },
                { name: 'Кол-во договоров', id: 'contractsCount', fieldClass: 'grid-cell' },
                { name: 'Эффективность', id: 'efficiency', fieldClass: 'grid-cell nowrap' },
                { name: 'Средняя скидка', id: 'discountPercent', fieldClass: 'grid-cell' }
            ],
            statColumnsInstaller: [
                { name: 'Кол-во рабочих дней', id: 'workingDaysCount', fieldClass: 'grid-cell' },
                { name: 'Сумма м2', id: 'sumSquareM2', fieldClass: 'grid-cell' },
                { name: 'Итого выдано', id: 'sumExpenses', fieldClass: 'grid-cell' },
                { name: 'Итого стоимость допов', id: 'sumAdditionalWork', fieldClass: 'grid-cell' }
            ],
            statColumnsManager: [
                { name: 'Кол-во рабочих дней', id: 'workingDaysCount', fieldClass: 'grid-cell' },
                { name: 'Кол-во сделок', id: 'dealsAllCount', fieldClass: 'grid-cell' },
                { name: 'Конверсия обращение/договор', id: 'contactByContract', fieldClass: 'grid-cell' }
            ]
        };
    },
    methods: {
        formatFinance,
        async getSummaryStatisticsEmployer(period, employerId) {
            this.loading = true;
            await this.$store.dispatch('salary/getSummaryStatisticsEmployer', { report_date: period, employer_id: employerId }).then(
                response => {
                    this.summaryStat = response.stat;
                    this.employerPositionId = response.employerPositionId;
                },
                error => {
                    if (error.response.status === 403) {
                        console.log(error.response.data.error);
                    }
                }
            ).finally(() => { this.loading = false; });
        }
    },
    computed: {
        title() {
            const date = this.reportDate.split('-');
            return 'Сводная статистика за ' + dateHelper.getMonthName(date[1]) + ' ' + date[0];
        },
        statColumns() {
            if (this.employerPositionId === localReferences.employerPositions.manager) {
                return this.statColumnsManager;
            }
            if (this.employerPositionId === localReferences.employerPositions.measurer) {
                return this.statColumnsMeasurer;
            }
            if (this.employerPositionId === localReferences.employerPositions.installer) {
                return this.statColumnsInstaller;
            }
            return [];
        }
    },
    mounted() {
        this.getSummaryStatisticsEmployer(this.reportDate, this.employerId);
    }
};
</script>
